import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getOriginalUrl } from '../utils/urlShortener';
import styled from 'styled-components';
import { generateClient } from 'aws-amplify/api';

const client = generateClient();

const ShortUrlRedirect = () => {
  const { shortCode } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    const redirect = async () => {
      try {
        const originalUrl = await getOriginalUrl(shortCode);
        if (originalUrl) {
          // Check if article exists
          const { data: article } = await client.models.Article.get({
            id: originalUrl.split('/').pop() // Get articleId from URL
          });
          
          if (!article) {
            setError(true);
            navigate('/404', { 
              state: { message: 'This article has been removed' }
            });
            return;
          }
          
          navigate(originalUrl, { replace: true });
        } else {
          setError(true);
          navigate('/404');
        }
      } catch (error) {
        console.error('Redirect error:', error);
        setError(true);
        navigate('/404');
      }
    };

    redirect();
  }, [shortCode, navigate]);

  if (error) {
    return null;
  }

  return (
    <LoadingContainer>
      <LoadingText>Redirecting...</LoadingText>
    </LoadingContainer>
  );
};

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const LoadingText = styled.div`
  color: #757575;
  font-size: 1.2rem;
`;

export default ShortUrlRedirect; 